import { IconName } from '@ardoq/icons';
import { WidgetTypes } from '@ardoq/api-types';
import { type I18nLocale, t } from '@ardoq/i18n';

export const getWidgetLabels = (
  i18nLocale: I18nLocale
): Record<WidgetTypes, string> => ({
  [WidgetTypes.PIE_CHART]: t(
    i18nLocale,
    'dashboard:widgets.types.pieChart',
    'Pie chart'
  ),
  [WidgetTypes.PERCENTAGE]: t(
    i18nLocale,
    'dashboard:widgets.types.percentage',
    'Percentage'
  ),
  [WidgetTypes.GAUGE]: t(i18nLocale, 'dashboard:widgets.types.gauge', 'Gauge'),
  [WidgetTypes.LINE_CHART]: t(
    i18nLocale,
    'dashboard:widgets.types.lineChart',
    'Line chart'
  ),
  [WidgetTypes.NUMBER]: t(
    i18nLocale,
    'dashboard:widgets.types.number',
    'Number chart'
  ),
  [WidgetTypes.TABLE]: t(i18nLocale, 'dashboard:widgets.types.table', 'Table'),
  [WidgetTypes.HEADER]: t(
    i18nLocale,
    'dashboard:widgets.types.header',
    'Header'
  ),
  [WidgetTypes.STACKED_BAR_CHART]: t(
    i18nLocale,
    'dashboard:widgets.types.stackedBarChart',
    'Stacked bar chart'
  ),
  [WidgetTypes.BAR_CHART]: t(
    i18nLocale,
    'dashboard:widgets.types.barChart',
    'Bar chart'
  ),
  [WidgetTypes.BUBBLE_CHART]: t(
    i18nLocale,
    'dashboard:widgets.types.bubbleChart',
    'Bubble chart'
  ),
  [WidgetTypes.NOTE]: t(i18nLocale, 'dashboard:widgets.types.note', 'Note'),
  [WidgetTypes.POWER_BI_IFRAME]: t(
    i18nLocale,
    'dashboard:widgets.types.powerBiWidget',
    'PowerBI Embed'
  ),
});

export const widgetIcons: Record<WidgetTypes, IconName> = {
  [WidgetTypes.TABLE]: IconName.VIEW_COMPACT,
  [WidgetTypes.NUMBER]: IconName.PLUS_ONE,
  [WidgetTypes.LINE_CHART]: IconName.LINE_CHART,
  [WidgetTypes.PIE_CHART]: IconName.PIE_CHART_FILLED,
  [WidgetTypes.PERCENTAGE]: IconName.PERCENTAGE,
  [WidgetTypes.GAUGE]: IconName.DONUT_CHART, // TODO need a gauge icon
  [WidgetTypes.STACKED_BAR_CHART]: IconName.STACKED_BAR_CHART,
  [WidgetTypes.BAR_CHART]: IconName.BAR_CHART,
  [WidgetTypes.BUBBLE_CHART]: IconName.BUBBLE_CHART,
  [WidgetTypes.HEADER]: IconName.NONE,
  [WidgetTypes.NOTE]: IconName.NONE,
  [WidgetTypes.POWER_BI_IFRAME]: IconName.POWER_BI,
};
export const widgetTypes = Object.values(WidgetTypes);
